var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9979 16.9999L25.0896 10.9224C25.3563 10.6557 25.5062 10.2939 25.5062 9.9166C25.5062 9.53934 25.3563 9.17753 25.0896 8.91077C24.8228 8.64401 24.461 8.49414 24.0837 8.49414C23.7065 8.49414 23.3447 8.64401 23.0779 8.91077L17.0004 15.0024L10.9229 8.91077C10.6561 8.64401 10.2943 8.49414 9.91707 8.49414C9.53981 8.49414 9.178 8.64401 8.91124 8.91077C8.64447 9.17753 8.49461 9.53934 8.49461 9.9166C8.49461 10.2939 8.64447 10.6557 8.91124 10.9224L15.0029 16.9999L8.91124 23.0774C8.77845 23.2091 8.67306 23.3658 8.60114 23.5385C8.52922 23.7111 8.49219 23.8963 8.49219 24.0833C8.49219 24.2703 8.52922 24.4555 8.60114 24.6281C8.67306 24.8007 8.77845 24.9574 8.91124 25.0891C9.04293 25.2219 9.19962 25.3273 9.37225 25.3992C9.54489 25.4711 9.73005 25.5082 9.91707 25.5082C10.1041 25.5082 10.2893 25.4711 10.4619 25.3992C10.6345 25.3273 10.7912 25.2219 10.9229 25.0891L17.0004 18.9974L23.0779 25.0891C23.2096 25.2219 23.3663 25.3273 23.5389 25.3992C23.7116 25.4711 23.8967 25.5082 24.0837 25.5082C24.2708 25.5082 24.4559 25.4711 24.6286 25.3992C24.8012 25.3273 24.9579 25.2219 25.0896 25.0891C25.2223 24.9574 25.3277 24.8007 25.3997 24.6281C25.4716 24.4555 25.5086 24.2703 25.5086 24.0833C25.5086 23.8963 25.4716 23.7111 25.3997 23.5385C25.3277 23.3658 25.2223 23.2091 25.0896 23.0774L18.9979 16.9999Z",
    fill: "#232738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.9ea6124f46998059d205e082b8cefd59.svg";
export { ForwardRef as ReactComponent };